import React,{ Component } from "react";
import { withRouter } from 'react-router-dom';
import { Form, FormControl, FormGroup, Col,  Button } from 'react-bootstrap';



import PreviewFiling from "./PreviewFiling";

import './BdcForm.scss';




const exportCSV = ({ files }) => {
  const headings = ['ShortName', 'Components', 'Value'];
  const csvContent = 'data:text/csv;charset=utf-8,' + headings.join(',') + '\n' + files.map((file) => {
    const values = [file.ShortName, file.Components, `"${file.Value}"`];
    return values.join(',');
  }).join('\n');

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', 'files.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

class BdcForm extends Component {
  state = {
   
   
    total_investments: '',
    cash: '',
    total_assets: '',
    total_debt: '',
    net_assets: '',
    net_assets_per_share_basic: '',
    net_assets_per_share_diluted:'',
    common_shares_issued:'',
    common_shares_outstanding:'',
    gross_revenue: '',
    interest_expense: '',
    management_fees: '',
    performance_incentive_fees: '',
    waiver_performance_incentive_fees:'',
    waiver_management_fees:'',
    total_expenses: '',
    net_investment_income: '',
    net_realized_gain_loss: '',
    net_unrealized_gain_loss: '',
    net_realized_unrealized_gain_loss: '',
    net_income: '',
    net_investment_income_per_share_basic:'',
    net_investment_income_per_share_diluted:'',
    earnings_per_share_basic: '',
    earnings_per_share_diluted:'',
    weighted_avg_shares_outstanding_basic:'',
    weighted_avg_shares_outstanding_diluted:'',
    dividends_per_share:'',
    share_buybacks_ytd:'',
    equity_issuances_ytd:'',
    distributions_paid:'',
    
    files:[]
    
  };



  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });

  };


  handleSubmit = (event) => {
    event.preventDefault();
    
    
  };
  

  handleClick = () => {

    const {
      total_investments,
      cash,
      total_assets,
      total_debt,
      net_assets,
      net_assets_per_share_basic,
      net_assets_per_share_diluted,
      common_shares_issued,
      common_shares_outstanding,
      gross_revenue,
      interest_expense,
      management_fees,
      performance_incentive_fees,
      waiver_performance_incentive_fees,
      waiver_management_fees,
      total_expenses,
      net_investment_income,
      net_realized_gain_loss,
      net_unrealized_gain_loss,
      net_realized_unrealized_gain_loss,
      net_income,
      net_investment_income_per_share_basic,
      net_investment_income_per_share_diluted,
      earnings_per_share_basic,
      earnings_per_share_diluted,
      weighted_avg_shares_outstanding_basic,
      weighted_avg_shares_outstanding_diluted,
      dividends_per_share,
      share_buybacks_ytd,
      equity_issuances_ytd,
      distributions_paid,
      
     } = this.state;
  
     const files = [
        {
          ShortName: 'total_investments',
          Components: 'Total Investments',
          Value: total_investments,
        },
        {
          ShortName: 'cash',
          Components: 'Cash',
          Value: cash,
        },
      
        {
          ShortName: 'total_assets',
          Components: 'Total Assets',
          Value: total_assets,
        },
        {
          ShortName: 'total_debt',
          Components: 'Total Debt',
          Value: total_debt,
        },
        {
          ShortName: 'net_assets',
          Components: 'Net Asset Value',
          Value: net_assets,
        },
        {
          ShortName: 'net_assets_per_share_basic',
          Components: 'Net Asset Per Share Basic',
          Value: net_assets_per_share_basic,
        },
        {
          ShortName: 'net_assets_per_share_diluted',
          Components: 'Net Assets Per Share Diluted',
          Value: net_assets_per_share_diluted,
        },
        {
          ShortName: 'common_shares_issued',
          Components: 'Common Shares Issued',
          Value: common_shares_issued,
        },
        {
          ShortName: 'common_shares_outstanding',
          Components: 'Common Shares Outstanding',
          Value: common_shares_outstanding,
        },
        {
          ShortName:'gross_revenue',
          Components:'Total Investment Income',
          Value: gross_revenue,
        },
        {
          ShortName:'interest_expense',
          Components:'Interest Expense',
          Value: interest_expense,
        },
        {
          ShortName:'management_fees',
          Components:'Management Fees',
          Value: management_fees,
        },
        {
          ShortName:'performance_incentive_fees',
          Components:'Incentive Fees',
          Value: performance_incentive_fees,
        },
        {
          ShortName:'waiver_performance_incentive_fees',
          Components:'Waiver Performance Incentive Fees',
          Value: waiver_performance_incentive_fees,
        },
        {
          ShortName:'waiver_management_fees',
          Components:'Waiver Management Fees',
          Value: waiver_management_fees,
        },
        {
          ShortName:'total_expenses',
          Components:'Total Expenses',
          Value: total_expenses,
        },
        {
          ShortName:'net_investment_income',
          Components:'Net Investment Income',
          Value: net_investment_income,
        },
        {
          ShortName:'net_realized_gain_loss',
          Components:'Net Realized Gains / (Losses)',
          Value: net_realized_gain_loss,
        },
        {
          ShortName:'net_unrealized_gain_loss',
          Components:'Net Change in Unrealized Gains / (Losses)',
          Value: net_unrealized_gain_loss,
        },
        {
          ShortName:'net_realized_unrealized_gain_loss',
          Components:'Net Realized and Unrealized Gain (Loss) on Investments',
          Value: net_realized_unrealized_gain_loss,
        },
        {
          ShortName:'net_income',
          Components:'Net Income',
          Value: net_income,
        },
        {
          ShortName:'net_investment_income_per_share_basic',
          Components:'Net Investment Income Per Share Basic',
          Value: net_investment_income_per_share_basic
        },
        {
          ShortName:'net_investment_income_per_share_diluted',
          Components:'Net Investment Income Per Share Diluted',
          Value: net_investment_income_per_share_diluted
        },
        {
          ShortName:'earnings_per_share_basic',
          Components:'Earning Per share Basic',
          Value: earnings_per_share_basic
        },
        {
          ShortName:'earnings_per_share_diluted',
          Components:'Earnings Per Share Diluted',
          Value: earnings_per_share_diluted
        },
        {
          ShortName:'weighted_avg_shares_outstanding_basic',
          Components:'Weighted Avg Shares Outstanding',
          Value: weighted_avg_shares_outstanding_basic
        },
        {
          ShortName:'weighted_avg_shares_outstanding_diluted',
          Components:'Weighted Avg Shares Outstanding Diluted',
          Value: weighted_avg_shares_outstanding_diluted
        },
        {
          ShortName:'dividends_per_share',
          Components:'Dividends Per Share',
          Value: dividends_per_share
        },
        {
          ShortName:'share_buybacks_ytd',
          Components:'Share Buybacks Ytd',
          Value: share_buybacks_ytd
        },
        {
          ShortName:'equity_issuances_ytd',
          Components:'Equity Issuances Ytd',
          Value: equity_issuances_ytd
        },
        {
          ShortName:'distributions_paid',
          Components:'Distributions Paid',
          Value: distributions_paid
        }
      ];
      
    exportCSV({ files });
    
  }
  

  render() {
    
    const{filings,docs}=this.props.location.state;  


    return (
      
      <div className="container-fluid pt-5" style={{ display: 'flex', flexDirection: 'row',width:"100vw",height:"100vh" }}>
         
        {/* Display the file in 70% of the page */}
        <div style={{ width: '70%'}}>
        <span className="card-title h2">{filings?.companyNameLong},{" "} <strong variant="info">{docs?.type}</strong></span>
          <div className="card documentViewControl scrollControl">
            
            <PreviewFiling filing={filings} doc={docs} selections={[]}  
                catalogue={[]} 
               onCatalogueAdd={this.props.onCatalogueAdd} 
              onCatalogueRemove={this.props.onCatalogueRemove} />
             
          </div>
       
      
        </div>

        {/* Display the form in 30% of the page */}
        <div style={{ width: '30%'}}>
          <div className="scrollControl documentViewControl" style={{marginTop:"10.5%"}}>
        <Form onSubmit={this.handleSubmit}>
        <FormGroup as={Col} controlId="total_investments" className="form-group">
          <Form.Label 
          className="form-label"
           style={{ fontSize: 14}}
           >
            Total Investments:
            </Form.Label>

<FormControl
          className="roundedEdges form-control"
           type="text"
           placeholder="Total Investments"
           name="total_investments"
           value={this.state.total_investments}
           onChange={this.handleChange}
           size="sm"
         />

</FormGroup>
<FormGroup as={Col} controlId="cash">
      <Form.Label column sm={2}
       style={{ fontSize: 14, padding: 2,paddingLeft:2,textAlign:"center"}}
       
    
      >
        Cash:
      </Form.Label>
      
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Cash"
          name="cash"
          value={this.state.cash}
          onChange={this.handleChange}
          size="sm"
        />
      
    </FormGroup>

    <FormGroup as={Col} controlId="total_assets">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
           >
        Total Assets:
      </Form.Label>
      
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Total Assets"
          name="total_assets"
          value={this.state.total_assets}
          onChange={this.handleChange}
          size="sm"
        />
      
    </FormGroup>

    <FormGroup as={Col} controlId="total_debt">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
           >
        Total Debt:
      </Form.Label>
      
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Total Debt"
          name="total_debt"
          value={this.state.total_debt}
          onChange={this.handleChange}
          size="sm"
        />
      
    </FormGroup>

    <FormGroup as={Col} controlId="net_assets">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
        Net Asset Value:
      </Form.Label>
      
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Net Asset Value"
          name="net_assets"
          value={this.state.net_assets}
          onChange={this.handleChange}
          size="sm"
        />
      
    </FormGroup>

    <FormGroup as={Col} controlId="net_assets_per_share_basic">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
           >
        Net Asset Per Share Basic:
      </Form.Label>
      
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Net Asset Per Share Basic"
          name="net_assets_per_share_basic"
          value={this.state.net_assets_per_share_basic}
          onChange={this.handleChange}
          size="sm"
        />
      
    </FormGroup>

    <FormGroup as={Col} controlId="net_assets_per_share_diluted">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
      Net Assets Per Share Diluted:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Net Assets Per Share Diluted"
          name="net_assets_per_share_diluted"
          value={this.state.net_assets_per_share_diluted}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

        <FormGroup as={Col} controlId="common_shares_issued">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
      Common Shares Issued:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Common Shares Issued"
          name="common_shares_issued"
          value={this.state.common_shares_issued}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

        <FormGroup as={Col} controlId="common_shares_outstanding">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
      Common Shares Outstanding:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Common Shares Outstanding"
          name="common_shares_outstanding"
          value={this.state.common_shares_outstanding}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

        <FormGroup as={Col} controlId="gross_revenue">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
           >
        Total Investment Income:
      </Form.Label>
      
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Total Investment Income"
          name="gross_revenue"
          value={this.state.gross_revenue}
          onChange={this.handleChange}
          size="sm"
        />
       
        </FormGroup>

        <FormGroup as={Col} controlId="interest_expense">
      <Form.Label style={{ fontSize: 14, padding: 2,paddingLeft:2,textAlign:"center"}}
           >
      Interest Expense:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Interest Expense"
          name="interest_expense"
          value={this.state.interest_expense}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>


        <FormGroup as={Col} controlId="management_fees">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
           >
      Management Fees:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Management Fees"
          name="management_fees"
          value={this.state.management_fees}
          onChange={this.handleChange}
          size="sm"
        />
  
        </FormGroup>

        <FormGroup as={Col} controlId="performance_incentive_fees">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
           >
      Incentive Fees:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Incentive Fees"
          name="performance_incentive_fees"
          value={this.state.performance_incentive_fees}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

        <FormGroup as={Col} controlId="waiver_performance_incentive_fees">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
      Waiver Performance Incentive Fees:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Waiver Performance Incentive Fees"
          name="waiver_performance_incentive_fees"
          value={this.state.waiver_performance_incentive_fees}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>
          
        <FormGroup as={Col} controlId="waiver_management_fees">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
      Waiver Management Fees:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Waiver Management Fees"
          name="waiver_management_fees"
          value={this.state.waiver_management_fees}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

        
        
        <FormGroup as={Col} controlId="total_expenses">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
      Total Expenses:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Total Expensess"
          name="total_expenses"
          value={this.state.total_expenses}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>
       
        <FormGroup as={Col} controlId="net_investment_income">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
           >
      Net Investment Income:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Net Investment Income"
          name="net_investment_income"
          value={this.state.net_investment_income}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

        <FormGroup as={Col} controlId="net_realized_gain_loss">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
           >
      Net Realized Gains / (Losses):
      </Form.Label>
     
        <FormControl
        
        className="roundedEdges"
          type="text"
          placeholder="Net Realized Gains / (Losses)"
          name="net_realized_gain_loss"
          value={this.state.net_realized_gain_loss}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

        <FormGroup as={Col} controlId="net_unrealized_gain_loss">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
           >
      Net Change in Unrealized Gains / (Losses):
      </Form.Label>
      
        <FormControl
         
        className="roundedEdges"
          type="text"
          placeholder="Net Change in Unrealized Gains / (Losses)"
          name="net_unrealized_gain_loss"
          value={this.state.net_unrealized_gain_loss}
          onChange={this.handleChange}
          size="sm"
        />
       
        </FormGroup>

        <FormGroup as={Col} controlId="net_realized_unrealized_gain_loss">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
           >
      Net Realized and Unrealized Gain (Loss) on Investments:
      </Form.Label>
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Net Realized and Unrealized Gain (Loss) on Investments"
          name="net_realized_unrealized_gain_loss"
          value={this.state.net_realized_unrealized_gain_loss}
          onChange={this.handleChange}
          size="sm"
        />
        </FormGroup>

        <FormGroup as={Col} controlId="net_income">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
      Net Income:
      </Form.Label>
      
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Net Income"
          name="net_income"
          value={this.state.net_income}
          onChange={this.handleChange}
          size="sm"
        />
       
        </FormGroup>

        
        <FormGroup as={Col} controlId="net_investment_income_per_share_basic">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
      Net Investment Income Per Share Basic:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Net Investment Income Per Share Basic"
          name="net_investment_income_per_share_basic"
          value={this.state.net_investment_income_per_share_basic}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

        <FormGroup as={Col} controlId="net_investment_income_per_share_diluted">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
     Net Investment Income Per Share Diluted:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Net Investment Income Per Share Diluted"
          name="net_investment_income_per_share_diluted"
          value={this.state.net_investment_income_per_share_diluted}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

        <FormGroup as={Col} controlId="Earning Per share Basic">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
      Earning Per share Basic:
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Earning Per share Basic"
          name="earnings_per_share_basic"
          value={this.state.earnings_per_share_basic}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>
        <FormGroup as={Col} controlId="earnings_per_share_diluted">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
     Earnings Per Share Diluted
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Earnings Per Share Diluted"
          name="earnings_per_share_diluted"
          value={this.state.earnings_per_share_diluted}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

        <FormGroup as={Col} controlId="weighted_avg_shares_outstanding_basic">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
     Weighted Avg Shares Outstanding Basic
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Weighted Avg Shares Outstanding Basic"
          name="weighted_avg_shares_outstanding_basic"
          value={this.state.weighted_avg_shares_outstanding_basic}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>
       
        <FormGroup as={Col} controlId="weighted_avg_shares_outstanding_diluted">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
     Weighted Avg Shares Outstanding Diluted
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Weighted Avg Shares Outstanding Diluted"
          name="weighted_avg_shares_outstanding_diluted"
          value={this.state.weighted_avg_shares_outstanding_diluted}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

      <FormGroup as={Col} controlId="dividends_per_share">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
     Dividends Per Share
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Dividends Per Share"
          name="dividends_per_share"
          value={this.state.dividends_per_share}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>
     <FormGroup as={Col} controlId="share_buybacks_ytd">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
     Share Buybacks Ytd
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Share Buybacks Ytd"
          name="share_buybacks_ytd"
          value={this.state.share_buybacks_ytd}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

        <FormGroup as={Col} controlId="equity_issuances_ytd">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
     Equity Issuances Ytd
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Equity Issuances Ytd"
          name="equity_issuances_ytd"
          value={this.state.equity_issuances_ytd}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>


        <FormGroup as={Col} controlId="distributions_paid">
      <Form.Label style={{ fontSize: 14, padding: 2 ,paddingLeft:2,textAlign:"center"}}
          >
     Distributions Paid
      </Form.Label>
     
        <FormControl
        className="roundedEdges"
          type="text"
          placeholder="Distributions Paid"
          name="distributions_paid"
          value={this.state.distributions_paid}
          onChange={this.handleChange}
          size="sm"
        />
        
        </FormGroup>

        <div className="text-center btn">

        <Button onClick={this.handleClick} variant="primary"  className="btn btn-info roundedEdges" >
          Export CSV
        </Button>
        
        </div>
        
      

      
        </Form>
       </div>
        </div>

       

      </div>
    );
  }
}

export default withRouter(BdcForm);

